import React from 'react';

interface Props {
  id: string;
  name: string;
  label: string;
  checked: boolean;
  onChange: (e) => void;
}

const AdminRadiobox: React.FC<Props> = ({
  id,
  name,
  label,
  checked,
  onChange,
}) => (
  <React.Fragment>
    <div className="radiobox-group">
      <input
        type="radio"
        name={name}
        id={id}
        onChange={onChange}
        defaultChecked={checked}
      />
      <label htmlFor={id}>{label}</label>
    </div>
    {/* language=CSS */}
    <style jsx>{`
      .radiobox-group label {
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
      }
    `}</style>
  </React.Fragment>
);

export default AdminRadiobox;
